export default __webpack_public_path__ + "static/media/stereo_05.9bc65f0a.gif";